import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Shield, AlertCircle, CheckCircle2, Clock } from 'lucide-react';
import { Footer } from '../components/Footer';
export function GuiaSosPage() {
  useEffect(() => {
    // Load Hotmart Sales Funnel Widget Script
    const script = document.createElement('script');
    script.src = 'https://checkout.hotmart.com/lib/hotmart-checkout-elements.js';
    script.async = true;
    script.onload = () => {
      if (window && (window as any).checkoutElements) {
        ;
        (window as any).checkoutElements.init('salesFunnel').mount('#hotmart-sales-funnel');
      }
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const fadeIn = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.6
    }
  };
  const scrollToOffer = () => {
    const el = document.getElementById('oferta-especial');
    if (el) {
      const yOffset = -100;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900 pt-10 md:pt-16 flex flex-col" data-id="element-826">
      <main className="max-w-3xl mx-auto px-4 pb-20 flex-grow w-full" data-id="element-827">
        {/* Módulo 1: El Reframing (Validación y Empatía) */}
        <motion.section {...fadeIn} className="text-center py-10 md:py-16" data-id="element-828">
          <h1 className="text-4xl md:text-5xl font-black text-[#2E7D32] leading-tight mb-6" data-id="element-829">
            Te entiendo perfectamente 💚
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 font-medium max-w-2xl mx-auto" data-id="element-830">
            Tal vez sientes que el protocolo de salud intestinal de 90 días es
            "demasiado" para procesar ahora mismo. Lo entiendo. Como mamás, a
            veces solo necesitamos soluciones para hoy.
          </p>
          <p className="text-xl font-bold text-gray-900 mt-8" data-id="element-831">
            Pero hay una realidad que no podemos ignorar...
          </p>
        </motion.section>

        {/* Módulo 2: El "Puente de Dolor" (Pintar el Escenario) */}
        <motion.section {...fadeIn} className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-gray-100 mb-12" data-id="element-832">
          <div className="text-lg md:text-xl text-gray-700 space-y-4 mb-10 text-center" data-id="element-833">
            <p data-id="element-834">
              El próximo moco no avisa. La próxima fiebre de las 3 de la mañana
              no pide permiso.
            </p>
            <p data-id="element-835">
              Y en ese momento, cuando tu hijo llora, no quiere comer nada y tú
              estás agotada...{' '}
              <strong className="text-red-600" data-id="element-836">
                improvisar es el error más caro que puedes cometer.
              </strong>
            </p>
          </div>

          <div className="my-10 text-center" data-id="element-837">
            <img src="https://cdn.magicpatterns.com/uploads/audehKbXSqMFVkchRGd9g4/GUIA_SOS_mockup.png" alt="Guía SOS Mockup" className="w-full max-w-sm mx-auto rounded-2xl shadow-2xl mb-8" data-id="element-838" />
            <button onClick={scrollToOffer} className="inline-block bg-[#2E7D32] hover:bg-[#1B5E20] text-white font-black text-lg md:text-xl px-8 py-4 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.03] active:scale-95 animate-pulse" data-id="element-839">
              SÍ, ME INTERESA LA GUÍA SOS
            </button>
          </div>

          <div className="bg-red-50 p-6 md:p-8 rounded-2xl border border-red-100" data-id="element-840">
            <p className="font-bold text-red-800 text-xl mb-6" data-id="element-841">
              Improvisar significa:
            </p>
            <ul className="space-y-4" data-id="element-842">
              <li className="flex items-start gap-3" data-id="element-843">
                <span className="text-red-500 font-bold text-xl shrink-0" data-id="element-844">
                  ❌
                </span>
                <span className="text-gray-800 text-lg" data-id="element-845">
                  Darle lácteos que aumentan el moco y alargan el resfrío.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-846">
                <span className="text-red-500 font-bold text-xl shrink-0" data-id="element-847">
                  ❌
                </span>
                <span className="text-gray-800 text-lg" data-id="element-848">
                  Forzarlo a comer cuando su cuerpo necesita ayunar para
                  defenderse.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-849">
                <span className="text-red-500 font-bold text-xl shrink-0" data-id="element-850">
                  ❌
                </span>
                <span className="text-gray-800 text-lg" data-id="element-851">
                  Terminar en la farmacia comprando jarabes que solo tapan el
                  síntoma pero no sanan la raíz.
                </span>
              </li>
            </ul>
          </div>
        </motion.section>

        {/* Módulo 3: El Producto como "Seguro Médico de Cocina" */}
        <motion.section {...fadeIn} className="bg-gradient-to-b from-[#E8F5E9] to-white rounded-[2.5rem] p-8 md:p-12 shadow-lg border border-[#C8E6C9] mb-16" data-id="element-852">
          <div className="text-center mb-10" data-id="element-853">
            <Shield className="w-16 h-16 text-[#2E7D32] mx-auto mb-6" data-id="element-854" />
            <h2 className="text-3xl md:text-4xl font-black text-[#2E7D32] mb-6 leading-tight" data-id="element-855">
              No necesitas 90 días de protocolo... necesitas 72 horas de CALMA.{' '}
              <span className="inline-block" data-id="element-856">🤒</span>
            </h2>
            <p className="text-lg text-gray-700" data-id="element-857">
              Por eso preparé algo exclusivo para las mamás de la comunidad
              NutriKids que necesitan una herramienta de rescate inmediata.
            </p>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-858">
            <p className="font-bold text-gray-900 text-xl mb-4" data-id="element-859">
              La GUÍA SOS: Qué comer cuando ya está enfermo es tu manual clínico
              de cocina.
            </p>
            <p className="text-gray-700 text-lg mb-8" data-id="element-860">
              No es teoría. Son instrucciones exactas para cuando la crisis ya
              empezó.
            </p>
            <ul className="space-y-5" data-id="element-861">
              {['Sabes qué CORTAR hoy mismo para que la enfermedad dure la mitad del tiempo.', 'Tienes 5 protocolos específicos por síntoma (Moco, Fiebre, Diarrea, Tos, Inapetencia).', '25 recetas de recuperación (desde el "Suero Casero" hasta la "Sopa Escudo Dorado") que los niños aceptan aunque no tengan hambre.', 'El Semáforo de Alimentos: Una guía visual para que hasta tu pareja o la abuela sepan qué darle sin meter la pata.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-862">
                  <CheckCircle2 className="w-6 h-6 text-[#4CAF50] shrink-0 mt-0.5" data-id="element-863" />
                  <span className="text-gray-800 font-medium text-lg" data-id="element-864">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </motion.section>

        {/* Módulo 4, 5 y 6: Oferta, Urgencia y CTA Final */}
        <motion.section id="oferta-especial" {...fadeIn} className="bg-white rounded-[2rem] shadow-xl border-4 border-[#E65100] mb-12" data-id="element-865">
          {/* Módulo 4: El Valor Irresistible */}
          <div className="bg-[#E65100] text-white text-center py-6 px-4 rounded-t-[calc(2rem-4px)]" data-id="element-866">
            <h2 className="text-2xl md:text-3xl font-black flex items-center justify-center gap-2" data-id="element-867">
              <Clock className="w-8 h-8 animate-pulse" data-id="element-868" />
              Una oportunidad única. Solo aquí. Solo ahora. ⏳
            </h2>
          </div>

          <div className="p-8 md:p-12" data-id="element-869">
            <div className="text-lg text-gray-700 space-y-4 mb-10 text-center" data-id="element-870">
              <p data-id="element-871">
                Esta guía tiene un valor regular de <strong data-id="element-872">$49.00 USD</strong>.
                Es el resultado de años de estudio en nutrición funcional
                aplicada a momentos de crisis.
              </p>
              <p data-id="element-873">
                Pero como acabas de confiar en NutriKids y mi misión es que no
                pases una sola noche más de angustia sin saber qué hacer...
              </p>
              <p className="text-xl font-bold text-gray-900 mt-6" data-id="element-874">
                No vas a pagar $49.
              </p>
              <p className="text-xl font-bold text-gray-900" data-id="element-875">
                Ni siquiera los $27 del protocolo anterior.
              </p>
              <p className="mt-6" data-id="element-876">
                Si sumas la GUÍA SOS a tu pedido en este preciso momento, el
                precio para ti es de:
              </p>
            </div>

            <div className="text-center mb-12" data-id="element-877">
              <h3 className="text-[2.7rem] md:text-[4rem] font-black text-[#2E7D32] mb-4 drop-shadow-sm leading-tight" data-id="element-878">
                💎 Solo $17.00 USD
              </h3>
              <p className="text-gray-500 italic font-medium text-lg" data-id="element-879">
                (Es menos de lo que cuesta un solo frasco de jarabe para la tos
                en la farmacia).
              </p>
            </div>

            {/* Módulo 6: El Llamado a la Acción Final */}
            <div className="text-center mb-8" data-id="element-880">
              {/* HOTMART WIDGET CONTAINER */}
              <div id="hotmart-sales-funnel" className="min-h-[100px] flex items-center justify-center mb-8 relative z-50" style={{
              pointerEvents: 'auto'
            }} data-id="element-881">
                {/* Widget mounts here */}
              </div>

              <div className="flex flex-wrap justify-center gap-6 text-sm md:text-base font-bold text-gray-600 mb-10" data-id="element-882">
                <span className="flex items-center gap-1" data-id="element-883">
                  <CheckCircle2 className="w-5 h-5 text-[#4CAF50]" data-id="element-884" /> Acceso
                  inmediato
                </span>
                <span className="flex items-center gap-1" data-id="element-885">
                  <CheckCircle2 className="w-5 h-5 text-[#4CAF50]" data-id="element-886" /> Un solo
                  pago
                </span>
                <span className="flex items-center gap-1" data-id="element-887">
                  <CheckCircle2 className="w-5 h-5 text-[#4CAF50]" data-id="element-888" /> Garantía
                  de 15 días
                </span>
              </div>

              <div className="bg-gray-50 p-6 md:p-8 rounded-2xl border border-gray-200 mb-10" data-id="element-889">
                <p className="text-xl md:text-2xl font-bold text-gray-800 italic" data-id="element-890">
                  "Prefiero tenerla y no necesitarla, que necesitarla y no
                  tenerla a las 3 de la mañana."
                </p>
              </div>

              <Link to="/negacion" className="inline-block text-gray-500 hover:text-gray-800 underline font-medium transition-colors text-lg" data-id="element-891">
                ¿No quieres asegurar la próxima crisis?
                <br data-id="element-892" />
                <span className="text-sm" data-id="element-893">
                  (Entiendo que perderé el descuento del 65% para siempre).
                </span>
              </Link>
            </div>

            {/* Módulo 5: La Urgencia Extrema */}
            <div className="bg-red-50 border border-red-200 rounded-2xl p-6 md:p-8 mb-12" data-id="element-894">
              <h4 className="font-black text-red-700 flex items-center gap-2 mb-4 text-xl" data-id="element-895">
                <AlertCircle className="w-6 h-6" data-id="element-896" /> ⚠️ ATENCIÓN:
              </h4>
              <div className="space-y-4 text-red-900 font-medium text-lg" data-id="element-897">
                <p data-id="element-898">Esta oferta NO volverá a aparecer.</p>
                <p data-id="element-899">
                  Si haces click en "No gracias" o cierras esta pestaña, el
                  sistema eliminará automáticamente el descuento del 65%.
                </p>
                <p data-id="element-900">
                  Si decides comprarla mañana, tendrás que pagar el precio total
                  de $49 USD. Esta es una atención exclusiva para clientes
                  nuevos de NutriKids que toman acción rápida.
                </p>
              </div>
            </div>
          </div>
        </motion.section>
      </main>

      <Footer data-id="element-901" />
    </div>;
}